import { configureStore } from "@reduxjs/toolkit";
import AuthReducer from "./features/authSlice";
import TourReducer from "./features/tourSlice";
import ContentReducer from "./features/contentSlice";
import TipsReducer from "./features/tipSlice";

export default configureStore({
  reducer: {
    auth: AuthReducer,
    tour: TourReducer,
    content: ContentReducer,
    tips: TipsReducer, 
  },
});
